import React from "react";
import { connect } from "react-redux";
import { fixedAmount } from "../../../helpers/icons";
import { languages } from "../../../helpers/language";
const DiscountItem = ({ merchantData, customerData, appStateData }) => {
  let { merchant } = merchantData;
  let { currentDiscountCode } = customerData;
  let { shopDomain } = appStateData;

  let details = {
    main_your_rewards:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.your_rewards"
      ],
    discount_off:
      languages[merchant?.customWidgetTheme?.language || "en"]["discount.off"],
    discount_desc:
      languages[merchant?.customWidgetTheme?.language || "en"]["discount.desc"],
    coupon_valid:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "discount.coupon_valid"
      ],
    apply_code:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "discount.apply_code"
      ],
    expiry_date:
      languages[merchant?.theme?.language || "en"]["discount.expiry_date"],
  };

  return (
    <div className="discountItem-wrapper">
      <div className="discountItem-primary-container">
        <div className="discountItem-primary-image-wrapper">
          <img
            className="discountItem-primary-image"
            src={currentDiscountCode.imgUrl ?? fixedAmount("#262626")}
            alt="icon"
          />
        </div>
        <div className="discountItem-primary-text-container">
          <p className="discountItem-primary-text">
            {currentDiscountCode.text ?? "- off coupon"}
          </p>
          <p className="discountItem-primary-subtext">
            {currentDiscountCode.desc ?? "- Points spent"}
          </p>
        </div>
      </div>
      <div className="discountItem-secondary-container">
        {currentDiscountCode.selectedOrder && (
          <p className="discountItem-secondary-text">
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? currentDiscountCode.selectedOrder === "all"
                ? merchant?.customWidgetTheme?.textCustomization?.forAllOrders
                : merchant?.customWidgetTheme?.textCustomization.couponValidForCollection?.replace(
                    "{{value}}",
                    currentDiscountCode.collectionName
                  )
              : `${details.coupon_valid} ${
                  currentDiscountCode.selectedOrder === "all"
                    ? "all orders."
                    : ""
                }${
                  currentDiscountCode.selectedOrder === "entitled"
                    ? currentDiscountCode.collectionName + " collection."
                    : ""
                }`}
          </p>
        )}

        {currentDiscountCode?.expiryDate && (
          <p className="discountItem-secondary-text">
            {details.expiry_date} :{" "}
            {new Date(currentDiscountCode?.expiryDate).toLocaleString("en-IN", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </p>
        )}

        <p className="discountItem-secondary-subtext">
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization
                ?.useThisDiscountCode
            : details.discount_desc}
        </p>
      </div>
      <div
        onClick={() => navigator.clipboard.writeText(currentDiscountCode.code)}
        className="discountItem-code-container"
      >
        <input readOnly value={currentDiscountCode.code ?? "fyfysf768"} />
        <button
          onClick={() =>
            navigator.clipboard.writeText(currentDiscountCode.code)
          }
          className="discountItem-copy-btn"
        ></button>
      </div>
      {/* Apply Code btn */}
      <div className="discountItem-apply-button-container">
        <button
          className="discountItem-apply-button"
          onClick={() =>
            window.open(
              `https://${shopDomain}/discount/${currentDiscountCode.code}`,
              "_PARENT"
            )
          }
        >
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.applyCodeButton
            : details.apply_code}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  // fetchMerchant: (shopDomain) => dispatch(fetchMerchant(shopDomain)),
  // setActivePage: (state) => dispatch(setActivePage(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscountItem);
